import { Tab } from '@atlassian/home-tab-selector/types';

import localStorageFacade from '@townsquare/facade/local-storage';

const LOCAL_STORAGE_KEY = 'tabs-whats-next';
const HAS_VIEWED_ASSIGNED_KEY = 'has-viewed-assigned';
const ASSIGNED_TAB = 'assigned';

export const getDefaultTabKey = (prioritiseAssigned: boolean): string | null => {
	const storedTabKey = localStorageFacade.getItem(LOCAL_STORAGE_KEY);
	const hasViewedAssigned = localStorageFacade.getItem(HAS_VIEWED_ASSIGNED_KEY);

	return prioritiseAssigned && !hasViewedAssigned ? ASSIGNED_TAB : storedTabKey;
};

export const getDefaultTabIndex = (tabs: Tab[], prioritiseAssigned: boolean): number => {
	const defaultTabKey = getDefaultTabKey(prioritiseAssigned);

	return Math.max(
		0,
		tabs.findIndex((tab) => tab.key === defaultTabKey),
	);
};

export const setTabInLocalStorage = (tabKey: string, prioritiseAssigned: boolean): void => {
	localStorageFacade.setItem(LOCAL_STORAGE_KEY, tabKey);

	if (prioritiseAssigned) {
		localStorageFacade.setItem(HAS_VIEWED_ASSIGNED_KEY, 'true');
	}
};
